export default __webpack_public_path__ + "static/media/Bottom Navigation.df2ebdf8.svg";